import { createSelector } from 'reselect';

const getSectorEntities = (store) => store.entities.sectors;

const getSectors = createSelector([getSectorEntities], (sectorEntities) => {
    return sectorEntities.allIds.map((id) => sectorEntities.byId[id]);
});

export default getSectors;
